module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_jd-7cbe8df5582a5fae57279bc4f0b28fa5.png";